import type { ReactNode } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type AppShellProps = {
  title: string;
  helperText: string;
  tabBar: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
};

export function AppShell({
  title,
  helperText,
  tabBar,
  headerAction,
  children,
}: AppShellProps) {
  return (
    <main className="app-shell">
      <Card className="app-shell__header">
        <CardHeader className="app-shell__header-content">
          <div className="app-shell__header-top">
            <CardTitle className="app-shell__title">{title}</CardTitle>
            {headerAction ? (
              <div className="app-shell__header-action">{headerAction}</div>
            ) : null}
          </div>
          <CardDescription className="app-shell__helper">
            {helperText}
          </CardDescription>
        </CardHeader>
      </Card>

      <Card className="app-shell__tabbar">
        <CardContent className="app-shell__tabbar-content">
          {tabBar}
        </CardContent>
      </Card>

      <Card className="app-shell__panel">
        <div className="app-shell__panel-content">{children}</div>
      </Card>
    </main>
  );
}
